import { createActionCreator } from '../../lib/Actions/factory';

const createAction = createActionCreator('SESSION');

export const INITIALIZE = createAction('INITIALIZE');
export const TWO_FACTOR_AUTH = createAction(
  'TWO_FACTOR_AUTH',
  ({ token, code }) => ({ token, code }),
);
export const AUTH = createAction('AUTH', ({ token, oauthUri, currentUserId, email }) => ({ token, oauthUri, currentUserId, email }));
export const DEAUTH = createAction('DEAUTH');
